import styled from 'styled-components';

const Button = styled.button`
  padding: 8px 25px;
  width: 100%;
  margin-right: 0;
  border-radius: 0.25rem;
  font-family: 'MerriweatherBold';
  font-size: 18px;
  background-color: #244f74;
  border: 2px solid #244f74;
  color: #FFFFFF;
`;

export default Button;
